import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';

import { useState, useRef, useEffect } from 'react';
import { useCallback } from 'react';
// material
import { styled } from '@material-ui/core/styles';
import {
  Stack,
  Drawer,
  Divider,
  Typography,
  Card
} from '@material-ui/core';
//
import Scrollbar from '../../components/Scrollbar';
import { useSnackbar } from 'notistack5';
import { useTranslation } from 'react-i18next';
// ----------------------------------------------------------------------
import useAuth from '../../hooks/useAuth'
import MyAvatar from '../../components/MyAvatar';
import Settings from './settings';
// ----------------------------------------------------------------------
export default function FormSettings({isOpen, onClose}) {
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();
  const { user } = useAuth();
  
  useEffect(() => {

  }, []);

  return (
    <>
      <Drawer open={isOpen} onClose={onClose} anchor="right" PaperProps={{ sx: { width: { xs: 1, sm: 690 } } }}>
        <Card
          sx={{
            backgroundColor: '#303187',
            py: 7,
            display: 'flex',
            position: 'relative',
            alignItems: 'center',
            flexDirection: 'column',
            borderRadius: '0px 0px 32px 32px',
            boxShadow: '0 0 0 5px #EF4137',
            borderBottom: '5px solid #48C8F4',
            height: '190px'
          }}
        >
          <Stack direction={"column"} justifyContent="center" alignItems="center" sx={{ mt: '-40px' }} >
            <MyAvatar fontSize={'50px'} width={'76px'} height={'76px'} alt={user.full_name} sx={{ mb: 3 }} />
            <Typography to="#" variant="subtitle1" sx={{ fontSize: '20px', fontWeight: '700', color: '#FEFEFE', lineHeight: '24px', mt: 2 }}>
              {user.full_name}
            </Typography>
            <Typography variant="body2" sx={{ color: '#FEFEFE' }}>
              {user.title_team}
            </Typography>
          </Stack>
        </Card>
        <Scrollbar sx={{ mt: 2 }}>
          <Stack sx={{ p: 2 }}>
            <Settings onClose={onClose}/>
          </Stack>
        </Scrollbar>
        <Divider />
      </Drawer>
    </>
  );
}
